import axios from 'axios';


export default {
    signIn (username, password) {
        var authenticationRequest = {username: username, password: password}
        return axios.post('/api/auth/signin', authenticationRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    refresh (refreshToken) {
        var request = {refreshToken: refreshToken}
        return axios.post('/api/auth/refresh', request)
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    register (email, pass, thename, code) {
        var registerRequest = {username:email, password: pass, name: thename, supplierCode: code}
        return axios.post('/api/auth/register', registerRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    logout () {
        return axios.post('/api/auth/logout')
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    getSuppliersImages () {
        return axios.get('/api/auth/suppliers-logo')
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    createCode (username, password, confPassword) {
        return axios.post('/api/auth/createCode', {username: username,password:password,confPassword:confPassword}  )
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
    },

    resetPassword (username, code) {
        return axios.post('/api/auth/resetPassword', {username: username,passwordCode:code}  )
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
    },


}

